if ($('#representantes-mapa').length) {
  /* Pins */

  let pins_representantes = [];

  if (typeof(estados) != 'undefined') {

    estados.forEach(function(estado) {

      pins_representantes.push(
        new ol.Feature({
          geometry: new ol.geom.Point(ol.proj.fromLonLat(estado.coordenadas)),
          name: estado.slug,
        })
      );
    });

  }

  //Definir centro do mapa de acordo com o breakpoint
  if ($(window).width() > 576) {
    //Tablets e Desktop
    var latitude_mapa = -55.874529675636644;
    var longitude_mapa = -23.409810928276787;
  }
  else {
    //Mobile
    var latitude_mapa = -45.827825621392;
    var longitude_mapa = -21.251766477693426;
  }

  /* Map */
  let mapa_representates = new ol.Map({
    target: 'representantes-mapa',
    interactions: ol.interaction.defaults({ dragPan: widthScreen > smartphone ? true : true, mouseWheelZoom: widthScreen > smartphone ? true : true }).extend([
      new ol.interaction.DragPan({
        condition: function(event) {
          return this.getPointerCount() === 2 || ol.events.condition.platformModifierKeyOnly(event);
        },
      }),
      new ol.interaction.MouseWheelZoom({
        condition: ol.events.condition.platformModifierKeyOnly,
      }),
    ]),
    layers: [
      new ol.layer.Tile({
        className: 'bw',
        source: new ol.source.OSM(),
      }),
      new ol.layer.Vector({
        source: new ol.source.Vector({
          className: 'icons',
          features: pins_representantes
        }),
        style: new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            scale: 1,
            src: $('#representantes-mapa').data('markers')
          })
        })
      }),
    ],
    view: new ol.View({
      center: ol.proj.fromLonLat([latitude_mapa, longitude_mapa]),
      zoom: widthScreen > smartphone ? 6 : 1,
      minZoom: 6
    })
  });

  /* Evento de clique */

  mapa_representates.on('click', function(evt) {
    const feature = mapa_representates.forEachFeatureAtPixel(evt.pixel, function(feature) {
      return feature;
    });
    if (pins_representantes.includes(feature)) {
      let propriedades = feature.getProperties();

      jQuery(".single-estado-container").addClass("hide");
      jQuery(".single-estado-container." + propriedades.name).removeClass("hide");

      //Se for mobile, dá um scroll de 450px pra baixo
      if ($(window).width() < 576) {
        var y = $(window).scrollTop();
        $(window).scrollTop(y + 450);
      }
    }
  });
}

$(document).ready(function() {

  setTimeout(function() {
    jQuery(".representantes-mapa-instrucoes").addClass("show");
    jQuery(".representantes-mapa-instrucoes").addClass("visible");
  }, 1000);

  setTimeout(function() {
    jQuery(".representantes-mapa-instrucoes").removeClass("visible");
  }, 5500);

  setTimeout(function() {
    jQuery(".representantes-mapa-instrucoes").removeClass("show");
  }, 6500);

});
